import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    templateUrl: './example-page.component.html',
    styleUrls: ['./example-page.component.css'],
    standalone: true,
    imports: [RouterLink]
})
export class ExamplePageComponent {

  public goBack(): void {
    window.history.back();
  }

}
